// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__SWpcY","search":"Settings_search__3miuH","filter":"Settings_filter__1TLpH"};